import { BREAKPOINTS } from '@general/js/_constants';
import { DeviceTypes } from '@/enums';

/**
 * Function that check the window size is desktop or not, a window resize event listener might need to be used when calling this functon
 *
 * @return {boolean} - True for Desktop, false for non desktop
 */
export const checkDesktopOrNot = () => {
  if (window.innerWidth > 940) {
    return true;
  }

  return false;
};

/**
 * Function that gets the device type based on the window width. Can be used with a window resize event listener.
 *
 * @param {Number} breakpoint Current width of the browser
 * @returns {String} Current device layout (desktop, tablet, mobile)
 */
export const getCurrentDeviceLayout = (breakpoint) => {
  if (breakpoint >= BREAKPOINTS.DESKTOP) {
    return DeviceTypes.DESKTOP;
  }
  if (breakpoint > BREAKPOINTS.TABLET && breakpoint < BREAKPOINTS.DESKTOP) {
    return DeviceTypes.TABLET;
  }
  return DeviceTypes.MOBILE;
};
